import { render, staticRenderFns } from "./TestModeLimitedCapacityAlert.vue?vue&type=template&id=25d072f6"
import script from "./TestModeLimitedCapacityAlert.vue?vue&type=script&lang=js"
export * from "./TestModeLimitedCapacityAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports